import request from '@/utils/request'
import store from '@/store'


export function getResSearchContentResult (keyWord,resoureCabpId,searchType,page,pageSize) {
  return request({
    url: '/api/resource/web/resSearch',
    method: 'get',
    params: {
      cabpid: resoureCabpId,
      keyword: keyWord,
      searchType:searchType,
      cpage:page,
      pageSize:pageSize
    }
  })
}

// 资源类型
export function getResourceTypes () {
  return request({
    url: '/api/userResource/web/categorys',
    method: 'get',
    params: {}
  })
}

// 机构类型
export function getOrganisedResourceTypes () {
  return request({
    url: '/api/branchResource/web/categorys',
    method: 'get',
    params: {}
  })
}

// 获取课程资源详细数据
export function getCourseResourceInfo (params) {
  return request({
    url: '/api/resourceAffiliate/web/info',
    method: 'get',
    params: params
  })
}

// 获取资源详细数据（根据资源id）
export function getResInfoByResId (params) {
  return request({
    url: '/api/resource/web/findById',
    method: 'get',
    params: params
  })
}


//获取商品详情
export function findProductCode(params){
  return request({
    url: '/api/product/web/findByCode',
    method: 'post',
    params: params
  })
}

//资源详情
export function getListResourceInfo(params){
  return request({
    url: '/api/productResource/web/listResourceInfo',
    method: 'get',
    params: params
  })
}
//库存
export function getSelectByCabpno(params){
  return request({
    url: '/api/inventory/web/selectByCabpno',
    method: 'get',
    params: params
  })
}

/** 获取最近一次的阅读记录 */
export function getCurrentUserLastOneByResourceId(params){
  return request({
    url: '/api/readRecordLog/web/getCurrentUserLastOneByResourceId',
    method: 'get',
    params: params
  })
}

/** 添加用户阅读主记录 */
export function readRecordLogSave(params,data){
  return request({
    url: '/api/readRecordLog/web/save',
    method: 'post',
    params: params,
    data: data
  })
}

//PDF-添加书签
export function getBookmarkSave(params,data){
  return request({
    url: '/api/bookmark/web/save',
    method: 'post',
    params: params,
    data: data
  })
}

//PDF-获取书签列表
export function getBookmarkSelectParam(params,data){
  return request({
    url: '/api/bookmark/web/selectParam',
    method: 'post',
    params: params,
    data: data
  })
}

//获取书签总列表list
export function getBookmarkSelectList(params,data){
  return request({
    url: '/api/bookmark/web/selectList',
    method: 'post',
    params: params,
    data: data
  })
}

//PDF-删除书签
export function bookmarkDelete(params,data){
  return request({
    url: '/api/bookmark/web/delete',
    method: 'post',
    params: params,
    data: data
  })
}

//资源的知识元列表
export function getResourceExplicitWordList(params,data){
  return request({
    url: '/api/resourceMark/web/resourceExplicitWordList',
    method: 'post',
    params: params,
    data: data
  })
}

//当前资源的知识元、集合、链路的类型
export function getResourceObjectType(params){
  return request({
    url: '/api/resourceMark/web/resourceObjectType',
    method: 'get',
    params: params
  })
}

//知识元的相关资源分类
export function getRecommendResourceCategoryList(params,data){
  return request({
    url: '/api/resourceMark/web/recommendResourceCategoryList',
    method: 'post',
    params: params,
    data: data
  })
}

//知识元的相关资源列表
export function getRecommendResourceList(params,data){
  return request({
    url: '/api/resourceMark/web/recommendResourceList',
    method: 'post',
    params: params,
    data: data
  })
}

//根据id查询知识元信息 前台
export function getFindById(params){
  return request({
    url: '/api/explicitWord/web/findById',
    method: 'get',
    params: params
  })
}

//用户阅读时查询当前阅读内容中的标引信息
export function webSelect(params,data){
  return request({
    url: '/api/resourceMark/web/webSelect',
    method: 'post',
    params: params,
    data: data
  })
}

//知识图谱
export function getDetailMap(params){
  return request({
    url: '/api/explicitWordRelation/web/detailMap',
    method: 'get',
    params: params
  })
}

/** 添加下载日志 */
export function downLoadLog(params,data){
  return request({
    url: '/api/downLoadLog/web/save',
    method: 'post',
    params: params,
    data: data
  })
}

/** 添加用户阅读记录详情 */
export function updateReadRecordLog(params,data){
  return request({
    url: '/api/readRecordDetail/web/save',
    method: 'post',
    params: params,
    data: data
  })
}

/** 加载阅读内容 */
export function getReadCon(params){
  return request({
    url: '/api/resource/web/read',
    method: 'get',
    params: params
  })
}

/** 获取目录列表 */
export function resourceCatalogList(params,data){
  return request({
    url: '/api/resourceCatalog/web/list',
    method: 'post',
    params: params,
    data: data
  })
}

/* 获取资源目录 */
export function getResourceCatalogs(params,data){
    return request({
        url: '/api/resource/web/courseCatalogs',
        method: 'get',
        params: params,
        data: data
    })
}

// 获取对应资源的列表
export function getResourceList(params,data){
    return request({
        url: '/api/resourceAffiliate/web/list',
        method: 'get',
        params,
        data
    })
}

// 获取对应视频资源的列表
export function getResourcePlayList(params,data){
    return request({
        url: '/api/resource/web/play',
        method: 'get',
        params,
        data
    })
}

//获取试卷信息
export function getExamList(params,data){
    return request({
        url:'/api/exercises/web/findExercisesById',
        method: 'get',
        params,
        data
    })
}

//获取简答题答案
export function getSaqAnswer(params,data){
    return request({
        url:'/api/exercises/web/findSaqAnswer',
        method: 'get',
        params,
        data
    })
}

//提交试卷
export function submitExam(params,data){
    return request({
        url:'/api/papersubmit/web/paperSubmit',
        method: 'post',
        params,
        data
    })
}

// 获取用户最新一次保存记录
export function getSubmitId(params,data){
    return request({
        url:'/api/papersubmit/web/selectNewestId',
        method: 'post',
        params,
        data
    })
}

// 获取试卷的答题记录
export function getNewExperId(params,data){
    return request({
        url:'/api/papersubmit//web/userPaperPape',
        method: 'post',
        params,
        data
    })
}
// 获取课程习题的类型
export function getExamType(params,data){
    return request({
        url:'/api/exercises/web/nature',
        method: 'get',
        params,
        data
    })
}

/** 获取资源目录 */
export function resCatalogData(params){
  return request({
    url: '/api/resource/web/resCatalogs',
    method: 'get',
    params: params
  })
}
  
/** 获取图集目录 */
export function resourceAffiliateCatalogData(params){
  return request({
    url: '/api/resourceAffiliate/web/list',
    method: 'get',
    params: params
  })
}

/** 添加书签 */
export function bookMarkSave(params,data){
  return request({
    url: '/api/bookmark/web/save',
    method: 'post',
    params: params,
    data:data
  })
}

/** 书签列表 */
export function bookMarkList(params,data){
  return request({
    url: '/api/bookmark/web/selectParam',
    method: 'post',
    params: params,
    data: data
  })
}

/** 书签列表list */
export function bookMarkSelect(params,data){
  return request({
    url:'/api/bookmark/web/selectList',
    method: 'post',
    params: params,
    data:data
  })
}

/** 阅读内容搜索 */
export function resSearch(params){
  return request({
    url:'/api/resource/web/resSearch',
    method: 'get',
    params: params
  })
}

/** 阅读内容搜索 - epub---new */
export function resSearchNew(params,data){
  return request({
    url:'/api/search/web/searchResource',
    method: 'post',
    params: params,
    data:data
  })
}


/** 加入书架 */
export function collectProduct(params){
  return request ({
    url:'/api/collectProduct/web/asyncSend',
    method: 'post',
    params: params
  })
}

/** 前台兑换 */
export function redeem(params,data){
  return request ({
    url:'/api/productRedeem/web/redeem',
    method: 'post',
    params: params,
    data:data
  })
}

/** 笔记列表 */
export function bookNote(params,data){
  return request ({
    url:'/api/bookNote/web/list',
    method: 'post',
    params: params,
    data:data
  })
}

/** 保存笔记 */
export function saveBookNote(params,data){
  return request ({
    url:'/api/bookNote/web/save',
    method: 'post',
    params: params,
    data:data
  })
}

/** 删除笔记 */
export function delBookNote(params){
  return request ({
    url:'/api/bookNote/web/delete',
    method: 'post',
    params: params
  })
}

/** 修改笔记 */
export function updateBookNote(params,data){
  return request ({
    url:'/api/bookNote/web/update',
    method: 'post',
    params: params,
    data:data
  })
}

/** 修改划线 */
export function updateMarks(params,data){
  return request ({
    url:'/api/dashMarks/web/update',
    method: 'post',
    params: params,
    data:data
  })
}

/** 新增划线 */
export function dashMarksSave(params,data){
  return request ({
    url:'/api/dashMarks/web/save',
    method: 'post',
    params: params,
    data:data
  })
}

/** 划线列表 */
export function dashMarksList(params,data){
  return request ({
    url:'/api/dashMarks/web/list',
    method: 'post',
    params: params,
    data:data
  })
}

/** 删除划线 */
export function dashMarksDelete(params,data){
  return request ({
    url:'/api/dashMarks/web/delete',
    method: 'post',
    params: params,
    data:data
  })
}
/** 添加用户访问日记 **/
export function asyncSave(params,data){
  return request ({
    url:'/api/visitLog/web/asyncSave',
    method: 'post',
    params: params,
    data:data
  })
}


/** 获取案例图片目录 */
export function getResImgs(params){
  return request ({
    url:'/api/resource/web/resImgs',
    method: 'get',
    params: params,
  })
}

/** 添加扫码日志 */
export function getScanLog(params,data){
  return request ({
    url:'/api/scanLog/web/asyncSave',
    method: 'post',
    params: params,
    data:data
  })
}

/** 获取标引列表 */
export function taglist(params,data){
  return request ({
    url:'/api/indexing/Tag/web/List',
    method: 'post',
    params: params,
    data:data
  })
}
export function readPics(params,data){
    return request ({
      url:'/api/resource/web/readPics',
      method: 'get',
      params: params,
      data:data
    })
  }
/*标引知识元、标准规范相关图书*/
export function GetWordRelationContent(params){
  return request ({
    url:'/api/indexing/Tag/web/GetWordRelationContent',
    method: 'get',
    params: params,
  })
}
/*根据商品代码资源id获取3D文件信息*/
export function webUserFind3DFiles(params){
  return request ({
    url:'/api/resource/web/webUserFind3DFiles',
    method: 'get',
    params: params,
  })
}
/*根据商品代码资源id获得全景图文件*/
export function webUserFindPanoramaFiles(params){
  return request ({
    url:'/api/resource/web/webUserFindPanoramaFiles',
    method: 'get',
    params: params,
  })
}
  /** 通义千问 单文档对话 */
export function singleDialogue(params,data){
  return request ({
    url:'/api/cabpAi/web/singleDialogue',
    method: 'post',
    params: params,
    data:data,
    timeout: 1000*180,
  })
}




/** ai 智能问答 */
export function api_ai_zhiNengWenDa_list(params,data)      { return request({ url: '/api/aiChat/web/chatTimes',       method: 'post', params ,data})}  /* 会话记录 */
export function api_ai_zhiNengWenDa_history(params,data)   { return request({ url: '/api/aiChat/web/chatHistory',     method: 'post', params ,data})}  /* 聊天记录 */
export function api_ai_zhiNengJiaoAn_export(params,data)   { return request({ url: '/api/aiChat/web/exportJiaoanWord',method: 'get',  params ,data, responseType:'blob', })}  /* 导出教案 */


// WEBPACK FOOTER //
// ./src/api/resources.js